import { render, staticRenderFns } from "./ImgWithDarkMode.vue?vue&type=template&id=035af080&scoped=true&"
import script from "./ImgWithDarkMode.vue?vue&type=script&lang=js&"
export * from "./ImgWithDarkMode.vue?vue&type=script&lang=js&"
import style0 from "./ImgWithDarkMode.vue?vue&type=style&index=0&id=035af080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035af080",
  null
  
)

export default component.exports